export function useClientAddresses(clients, clientId) {

    if ( !clients ) {
        return []
    }

    let clientAddresses = []
    clients.forEach(client => {
        if ( !clientId ) {
            clientAddresses = [ ...clientAddresses, ...client.clientAddresses ]
        }
        else if ( parseInt(client.id) === parseInt(clientId) ) {
            clientAddresses = client.clientAddresses
        }
    });

    return clientAddresses
}